import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';
import SITE from '../../../Data/siteConfig';
import './navbarRight.css';

export const NAV_LINKS = [
  { to: '/', label: 'Anasayfa', end: true },
  { to: '/hakkimizda', label: 'Hakkımızda' },
  { to: '/servislerimiz', label: 'Servislerimiz' },
  { to: '/iletisim', label: 'İletişim' },
  { to: '/konum', label: 'Konum' },
];

const NavbarRight = ({ mobile = false, onNavigate }) => {
  const linkClass = ({ isActive }) =>
    `nav-link${isActive ? ' nav-link--active' : ''}${mobile ? ' nav-link--mobile' : ''}`;

  return (
    <nav
      className={`nav-links${mobile ? ' nav-links--mobile' : ''}`}
      aria-label={mobile ? 'Mobil menü' : 'Ana menü'}
    >
      <ul className="nav-links-list">
        {NAV_LINKS.map(({ to, label, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              className={linkClass}
              onClick={onNavigate}
            >
              {label}
            </NavLink>
          </li>
        ))}
      </ul>

      <a
        href={SITE.phoneHref}
        className={`nav-cta${mobile ? ' nav-cta--mobile' : ''}`}
        onClick={onNavigate}
      >
        <FaPhoneAlt aria-hidden />
        <span>{mobile ? 'Hemen Ara' : SITE.phoneDisplay}</span>
      </a>
    </nav>
  );
};

export default NavbarRight;
